import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import AOS from "aos";
import "aos/dist/aos.css";
import i18n from "./i18n";
import store from "./state/store";
import websocket from "./state/websocket";
import BootstrapVue3 from "bootstrap-vue-3";
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import Head from "@/components/devices/Head";

import Maska from "maska";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";

import VueFeather from "vue-feather";
import Particles from "particles.vue3";
import vue3PreviewImage from "vue3-preview-image";

import "@/assets/scss/config/default/app.scss";
import "@vueform/slider/themes/default.css";
import "@/assets/scss/mermaid.min.css";
// import { initFirebaseBackend } from './authUtils'
// import { configureFakeBackend } from './helpers/fake-backend';
import "@/utils/common.scss";
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import Pagination from "@/components/Pagination.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import Top from "@/components/common/Top_title.vue";
import CockpitTree from "@/components/cockpitTree";

import flatpickrOrigin from "flatpickr";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Mandarin } from "flatpickr/dist/l10n/zh.js";
import { english } from "flatpickr/dist/l10n/default.js";
flatpickrOrigin.localize(
  i18n.global.locale.value === "en" ? english : Mandarin
);

import MessageAlert from "@/components/MessageAlert";
import loading from "@/components/common/Loading.js"; // 引入loading
import "./calendar.scss";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import en from "element-plus/dist/locale/en.mjs";
import { permissionMixin } from "@/mixins/permissionMixin";
import { refreshTokenHandle } from "@/helpers/common";

const app = createApp(App);

app.config.globalProperties.$websocket = websocket;
app.config.globalProperties.$tz = localStorage.getItem("tz") || "Asia/Shanghai";

export const orignalSetItem = localStorage.setItem;
localStorage.setItem = function (key, newValue) {
  // 要监听的key为approveCount
  if (
    key === "valueAnnotation" ||
    key === "username" ||
    key === "password" ||
    key === "accessToken" ||
    key === "refreshToken" ||
    key === "expiresAt" ||
    key === "refreshExpiresIn" ||
    key === "historyData" ||
    key === "equipmentData" ||
    key === "tz" ||
    key === "searchValue" ||
    key === "daterange" ||
    key === "dataZoom" ||
    key === "parId" ||
    key === "inumList" ||
    key === "layer_num"
  ) {
    var setItemEvent = new Event("setItemEvent");
    setItemEvent.newValue = newValue;
    window.dispatchEvent(setItemEvent);
  }
  if (key === "user") {
    var setUserEvent = new Event("setUserEvent");
    setUserEvent.newValue = newValue;
    window.dispatchEvent(setUserEvent);
  }
  orignalSetItem.apply(this, arguments);
};
// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
//     appId: process.env.VUE_APP_APPId,
//     measurementId: process.env.VUE_APP_MEASUREMENTID
// };
// if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
//     initFirebaseBackend(firebaseConfig);
// } else {
//     configureFakeBackend();
// }
// FakeBackend authentication
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();

// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);

app.component("Layout", Layout);
app.component("PageHeader", PageHeader);
app.component("Head", Head);
app.component("CockpitTree", CockpitTree);
app.component("Pagination", Pagination);
app.component("Multiselect", Multiselect);
app.component("flatPickr", flatPickr);
app.component("message-alert", MessageAlert);
app.component(Top.name, Top);
AOS.init({
  easing: "ease-out-back",
  duration: 1000,
});

app.directive("perm", (el, binding) => {
  // 这会在 `mounted` 和 `updated` 时都调用
  let code = binding.value;
  let hasPerm = store.getters["permission/isGuranted"](code);
  !hasPerm && el.parentNode && el.parentNode.removeChild(el);
});

app
  .use(router)
  .use(store)
  .use(ElementPlus, {
    locale: i18n.global.locale.value === "en" ? en : zhCn,
  })
  .use(VueApexCharts)
  .use(BootstrapVue3)
  .component(VueFeather.type, VueFeather)
  .use(Maska)
  .use(Particles)
  .use(vue3PreviewImage)
  .use(loading)
  .use(i18n)
  .use(vClickOutside)
  .mixin(permissionMixin)
  .use(Antd)
  .mount("#app");

setInterval(() => {
  // console.log("check token")
  let now = new Date().getTime() / 1000;
  // console.log(now)

  let accessToken = localStorage.getItem("accessToken");
  let expiresAt = localStorage.getItem("expiresAt");
  let refreshToken = localStorage.getItem("refreshToken");
  let refreshExpiresIn = localStorage.getItem("refreshExpiresIn");
  if (!refreshToken || !refreshExpiresIn) {
    return;
  }
  refreshExpiresIn = new Date(refreshExpiresIn).getTime() / 1000;
  // console.log(refreshExpiresIn)
  if (refreshExpiresIn <= now) {
    return;
  }
  if (accessToken && expiresAt) {
    expiresAt = new Date(expiresAt).getTime() / 1000;
    // console.log(expiresAt)
    if (expiresAt <= now) {
      localStorage.clear();
      window.location.href = "/";
    }
    let diff = expiresAt - now;
    if (0 < diff && diff <= 300) {
      refreshTokenHandle(refreshToken);
    }
  }
}, 6000);
